var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Scene",attrs:{"id":"Scene"}},[_c('div',{ref:"wrapper",staticClass:"Scene_wrapper"}),_c('div',{staticClass:"Scene_mask"})])}
var staticRenderFns = []

export { render, staticRenderFns }